import { optimizedResize } from '../util/optimizeresize'
import Mq from '../util/mq'

export default class SectionTabs {
  constructor($el) {
    this.$el = $($el)
    this.$panels = this.$el.find('.js-tabs-panel')

    this.setHeight(this.$panels)
    optimizedResize.add(() => {
      this.setHeight(this.$panels)
    })
  }

  setHeight($el) {
    if (Mq.minWidth('--md').matches) {
      let height = 0
      $($el)
        .each(function(i, tabPanel) {
          if ($(tabPanel).outerHeight() > height) {
            height = $(tabPanel).outerHeight()
          }
        })
        .css('min-height', height)
    } else {
      $($el).css('min-height', '')
    }
  }
}
